

















































import { Component, Vue } from "vue-property-decorator";
import { domain, VueForm } from "@/domain";
import * as uiUtil from "@/uiUtil";
import QuickSnack from "@/components/QuickSnack.vue";
import Password from "@/components/Password.vue";

@Component({
  components: { QuickSnack, Password }
})
export default class ChangePasswordPanel extends Vue {
  snackbar = "";
  isLoading = false;

  oldPassword = "";
  newPassword = "";
  validChangePassword = true;

  get lang() {
    return this.$store.state.lang.data;
  }

  get checkLowercase() {
    for (const char of this.newPassword) {
      if (char >= "a" && char <= "z") {
        return true; // Found a lowercase letter
      }
    }
    return false; // No lowercase letters found
  }

  get checkUppercase() {
    for (const char of this.newPassword) {
      if (char >= "A" && char <= "Z") {
        return true; // Found an uppercase letter
      }
    }
    return false; // No uppercase letters found
  }

  get checkNumber() {
    for (const char of this.newPassword) {
      if (!Number.isNaN(Number.parseInt(char))) {
        return true;
      }
    }
    return false; // No digits found
  }

  get checkNonAlphanumeric() {
    return /[^a-zA-Z0-9]/.test(this.newPassword);
  }

  get checkLenght() {
    if (this.newPassword.length > 7) return true;
    return false;
  }

  get disableBtn() {
    if (
      !this.checkLowercase ||
      !this.checkUppercase ||
      !this.checkNumber ||
      !this.checkNonAlphanumeric ||
      !this.checkLenght
    )
      return true;
    return false;
  }

  async cmdChangePassword() {
    if ((this.$refs.changePassword as VueForm).validate()) {
      this.isLoading = true;
      try {
        await domain.backend.changePassword(this.oldPassword, this.newPassword);
        this.snackbar = this.lang.successfulChangePassword;
        (this.$refs.changePassword as VueForm).reset();
      } catch (err) {
        this.snackbar = uiUtil.toErrorMsg(err as Error, this.lang.errorChangePassword);
      }
      this.isLoading = false;
    }
  }
}
